import { Typography } from '@mui/material';
import { PRIVACY_PDF_URL } from '../privacy.constants';
import { PrivacyComponentStyled } from './privacyComponent.styled';

const PrivacyComponent = () => {
  return (
    <PrivacyComponentStyled>
      <Typography variant="h3">Privacy Policy</Typography>
      <iframe
        src={PRIVACY_PDF_URL}
        className="iframe"
        title="Privacy Policy"
      ></iframe>
    </PrivacyComponentStyled>
  );
};

export default PrivacyComponent;
